import { render, staticRenderFns } from "./CourseSearchResultCard.vue?vue&type=template&id=1b43049c&"
import script from "./CourseSearchResultCard.vue?vue&type=script&lang=js&"
export * from "./CourseSearchResultCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports